import React,{useEffect,useState} from 'react';
import './home_banner.css';
import {sortList} from '../function_lib/common_lib';
import TextToHtml from './text_html';
import { appGetUrlPath } from '../function_lib/common_cms';

export const Comp_Latest_News_Vertical=(props)=>{
    // alert(JSON.stringify(props))
return(<div className='col-12 col-md-4 d-flex flex-column flex-md-row'>
    <div class="dual-section-container">
                 <div class="card">
                     <div class="card-header">
                        {props.lsData.length>0?
                         <h4 class="white"><i class="fa fa-newspaper-o"></i>{props.lsData[0]["g_title"]}</h4>:''}
                     </div>
                     <div class="card-body">
                     
                         <div class="scroll-content">
                         {props.lsData.map((item,index)=>{
                            var urlTitle= item["col1"];
                            urlTitle=urlTitle.replace("?","_");
                            urlTitle=urlTitle.replace(" ","-");
                            let clpUrl="..\\blog\\"+urlTitle+"?rf="+item["e_id"];
                            if(item["col7"]!==""){
                                clpUrl="..\\"+item["col7"];
                            }
                            if(item["col7"]==="read_now"){
                                //alert("i m in condition "+lsData[i]["col7"]+urlTitle+"?rf="+lsData[i]["e_id"]);
                                clpUrl="..\\"+item["col7"]+"\\"+urlTitle+"?rf="+item["e_id"];
                                //alert(clpUrl);
                            }
                            if(item["col7"].indexOf("://")!==-1){
                               clpUrl=item["col7"];
                            }
    
                            return <a href={clpUrl} class="news-item">
                            <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                            <div class="news-content">
                            
                                {/* <span class="news-category cat-tech">BSN</span> */}
                                <div class="news-title">{item["col1"]}</div>
                                {/* <div class="news-excerpt">{item["col2"]}</div> */}
                                {/* <div class="news-meta">
                                    <span><i class="fa fa-clock-o"></i> 15 min ago</span>
                                </div> */}
                            </div>
                        </a>
                        })}
                        </div>
                     </div>
                 </div>
             </div>
    </div>
    )
}
export default Comp_Latest_News_Vertical;